import { CUSTOM_FUNCTIONALITIES } from '@/lib/permissions/custom-functionalities';
import type { SearchCollection } from '../model/types';

export const SEARCH_GRANTS = {
  spaces: CUSTOM_FUNCTIONALITIES.DW_SEARCH_SPACE,
  generalerrands: CUSTOM_FUNCTIONALITIES.DW_SEARCH_GENERAL_ERRAND,
  invoices: CUSTOM_FUNCTIONALITIES.DW_SEARCH_INVOICE,
} as const satisfies Record<SearchCollection, string>;

export const SEARCH_COLLECTIONS = Object.keys(
  SEARCH_GRANTS
) as SearchCollection[];

/** Search collections require an explicit grant, including on legacy profiles. */
export function permittedSearchCollections(
  grants: readonly string[] | null | undefined
) {
  return SEARCH_COLLECTIONS.filter(
    (collection) => grants?.includes(SEARCH_GRANTS[collection]) === true
  );
}

export function searchDescription(
  collections: readonly SearchCollection[]
): string {
  const subjects: string[] = [];
  if (collections.includes('spaces'))
    subjects.push('hyresgäster', 'avtal', 'objekt');
  if (collections.includes('generalerrands')) subjects.push('ärenden');
  if (collections.includes('invoices')) subjects.push('avier', 'fakturor');
  if (!subjects.length) return 'Du saknar behörighet att söka i systemet.';
  return `Sök bland ${new Intl.ListFormat('sv', { type: 'conjunction' }).format(subjects)}.`;
}
